// packages
import { h } from 'preact';
import * as d3 from 'd3';
import * as moment from 'moment';
import _ from 'lodash';

// data
import data from '../../../data/data.json';

// components
import PureComponent from './PureComponent';

class SigUnemploymentRate extends PureComponent {
  constructor() {
    super();

    this.getContainerWidth = this.getContainerWidth.bind(this);
    this.createChart = this.createChart.bind(this);
    this.redrawChart = this.redrawChart.bind(this);

    this.state = {
      containerWidth: null,
      bodyWidth: null,
      breakPoint: 544,
    };
  }

  createChart() {
    let { containerWidth, bodyWidth, breakPoint } = this.state;
    let width = 50,
      height = 19;

    let margin = {
      top: 0,
      right: 8,
      left: 8,
      bottom: 0,
    };

    let chartWidth = width - margin.left - margin.right,
      chartHeight = height - margin.top - margin.bottom;

    // grab the data we need
    let rateData = data.unemployment_rate;

    // changing to moment date+time objects
    rateData.forEach(d => (d.date = moment(d.date, 'YYYY MMM')));

    // filter for after a date
    let sigData = rateData.filter(d =>
      d.date.isSameOrAfter(moment('2020 Feb', 'YYYY MMM'))
    );

    // grabbing totals and ranges
    let dateRange = d3.extent(sigData, d => d.date),
      totalsMax = 15; // hard coded

    // append svg
    let svg = d3
        .select('.sig-unemployment-rate-chart')
        .append('svg')
        .attr('width', width)
        .attr('height', height),
      g = svg
        .append('g')
        .attr('transform', `translate(${margin.left}, ${margin.top})`);

    // set scale domains
    let x = d3
      .scaleTime()
      .domain(dateRange)
      .range([0, chartWidth]);
    let y = d3
      .scaleLinear()
      .domain([0, totalsMax])
      .range([chartHeight, 0])
      .nice();

    let path = g
      .append('path')
      .data([sigData])
      .attr('class', 'line')
      .attr('fill', 'none')
      .attr('stroke', '#529aad')
      .attr('stroke-width', 2);

    g.append('path')
      .data([sigData])
      .attr('fill', '#529aad')
      .attr('opacity', 0.2)
      .attr(
        'd',
        d3
          .area()
          .x(function(d) {
            return x(d.date);
          })
          .y0(y(0))
          .y1(function(d) {
            return y(d.value);
          })
      );

    // Add rate lines
    let line = d3
      .line()
      .x(d => x(d.date))
      .y(d => y(d.value));

    path.attr('d', line);
  }

  redrawChart() {
    const { county, section } = this.props;

    d3.selectAll('.sig-unemployment-rate-chart svg').remove();

    let { containerWidth, bodyWidth } = this.getContainerWidth();
    this.setState({ containerWidth: containerWidth, bodyWidth: bodyWidth });

    this.createChart(county, section);
  }

  getContainerWidth() {
    let base = d3.select('#sig-unemployment-rate');
    const body = d3.select('body');

    const containerWidth = base.node().offsetWidth;
    const bodyWidth = body.node().offsetWidth;

    return { containerWidth, bodyWidth };
  }

  componentDidMount() {
    const { county, section } = this.props;
    let { containerWidth, bodyWidth } = this.getContainerWidth();

    this.setState(
      { containerWidth: containerWidth, bodyWidth: bodyWidth },
      () => {
        this.createChart(county, section);
      }
    );

    window.addEventListener(
      'resize',
      _.debounce(() => {
        this.redrawChart();
      }, 200)
    );
  }

  componentWillUnmount() {
    window.addEventListener(
      'resize',
      _.debounce(() => {
        this.redrawChart();
      }, 200)
    );
  }

  render() {
    return <div class="sig-unemployment-rate-chart"></div>;
  }
}

export default SigUnemploymentRate;
